import React from 'react';
import {Avatar, Dropdown, Menu, Badge} from "antd";
import {useQuery} from 'react-query'
import {GetProfile} from '../../../api/profile';
import {AppstoreOutlined, LogoutOutlined, NotificationOutlined, UserOutlined, DownOutlined} from '@ant-design/icons';

export const UserPanel = (props) => {
    const { data } = useQuery('profile', GetProfile);

    return (
        <>
            {(!data || !data.session) && (
                <>
                    <a className="btn btn-blue btn-sign_in" href="/profile/sign_in">Войти</a>
                    <a className="btn btn-blue btn-sign_out" href="/profile/sign_up">Регистрация</a>
                </>
            )}
            {(data && data.session) && (
                <UserHeader profile={data.profile || {}}/>
            )}
        </>
    );
}

const UserHeader = ({profile}) => {
    const DropDownMenu = (
        <Menu>
            <Menu.Item key={`notifications`} icon={<NotificationOutlined/>}>
                <a href={`/profile/notifications`} className={`block__notifications`}>
                    <span>Уведомления</span>
                    {profile.is_approved === false && <Badge count={1} />}
                </a>
            </Menu.Item>
            <Menu.Item key={`profile`} icon={<UserOutlined/>}><a href={`/profile`}>Профиль</a></Menu.Item>
            <Menu.Item key={`developer`} icon={<AppstoreOutlined/>}><a href={`/console`}>Войти как разработчик</a></Menu.Item>
            <Menu.Item key={`logout`} icon={<LogoutOutlined/>}><a href={`/profile/logout`}>Выйти</a></Menu.Item>
        </Menu>
    );

    const buildUserName = () => {
        let params = [];
        if (profile.first_name.length > 0) {
            params.push(profile.first_name[0])
        }
        if (profile.last_name.length > 0) {
            params.push(profile.last_name[0])
        }
        return params.join('');
    }

    // const triggers =

    const isTouchCapable = 'ontouchstart' in window ||
        window.DocumentTouch && document instanceof window.DocumentTouch ||
        navigator.maxTouchPoints > 0 ||
        window.navigator.msMaxTouchPoints > 0;

    return (
        <Dropdown overlay={DropDownMenu} trigger={isTouchCapable ? ['click'] : ['click', 'hover']}>
            <div className="user--header">
                <span
                    className={`user--name`}>{profile.first_name} {profile.last_name.length > 0 ? profile.last_name[0] + "." : ""}</span>
                <Badge count={profile.is_approved === false ? 1 : 0}><Avatar
                    size={48}
                    shape={`circle`}
                    style={{backgroundColor: '#0d4cd3', color: '#FFF'}}
                >
                    {buildUserName()}
                </Avatar></Badge>
                <DownOutlined />
            </div>
        </Dropdown>
    );
}

export default UserPanel;